import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import { Box, IconButton, Typography } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { debounce } from "lodash";

import { DownloadDocumentOfNotificationResponse } from "../../models/api/Referral";
import { DownloadDocumentOfNotificationActionDispatchTypes } from "../../constants/Referral";
import { resetStates } from "../../actions/Common";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export interface PropsFromState {
  downloadDocumentOfNotificationState: DownloadDocumentOfNotificationResponse;
  setIsPdfViewerOpen?: (value: boolean) => void;
  notificationBlobId?: number | null;
}

export interface PropsFromDispatch {
  downloadDocumentOfNotification: (blobId: number) => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const PdfViewer: React.FC<AllProps> = ({
  downloadDocumentOfNotificationState,
  downloadDocumentOfNotification,
  notificationBlobId,

}) => {
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);
  const [numPages, setNumPages] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const blobId = notificationBlobId;

  const { response: documentDownloadResponse } = downloadDocumentOfNotificationState;

  useEffect(() => {
   const debounceEffect = debounce(() => {
      if (blobId) {
        setPdfBlob(null);
        if (!isNaN(blobId)) {
          downloadDocumentOfNotification(blobId);
        }
      }
    }, 100);
    debounceEffect();
  }, [blobId]);

  useEffect(() => {
    if (documentDownloadResponse && documentDownloadResponse.blob) {
      const blob = new Blob([documentDownloadResponse.blob], {
        type: "application/pdf",
      });
      setPdfBlob(blob);
    }
  }, [documentDownloadResponse]);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setCurrentPage(1);
  };

  useEffect(()=>{
    return () => {
      resetStates(DownloadDocumentOfNotificationActionDispatchTypes.DOWNLOAD_DOCUMENT_OF_NOTIFICATION_RESET);
      setPdfBlob(null);
    }
  },[])

  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
      {pdfBlob && (
        <>
        <Box display="flex" alignItems="center" justifyContent="center" gap={2} mb={1}>
              <IconButton
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage <= 1}
              >
          &#8592;
          </IconButton>
              <Typography variant="body1">
                Page {currentPage} of {numPages}
              </Typography>
              <IconButton
                onClick={() => setCurrentPage((p) => Math.min(p + 1, numPages))}
                disabled={currentPage >= numPages}
              >
                &#8594;
              </IconButton>
        </Box>
             <Box display="flex" justifyContent="center">
              <Document
                file={pdfBlob}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<Typography>Loading PDF…</Typography>}
                error={<Typography color="error">Failed to load PDF.</Typography>}
              >
                <Page pageNumber={currentPage} width={1000} />
              </Document>
            </Box>
        </>
      )}
      </Grid>
    </Grid>
  );
};

export default PdfViewer;